import * as React from "react";
import {none, option, Option} from "ts-option";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Toast from "../../helper/Toast";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import DatePickerWithIcon from "../../../hiberUiKit/src/molecules/DatePickerWithIcon/DatePickerWithIcon";
import Payment, {PaymentMethod} from "../../../model/payment/Payment";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {api} from "../../../api/api";
import CurrencyInputWithIcon from "../../../hiberUiKit/src/atoms/Input/CurrencyInputWithIcon";
import "../invoiceDetails/invoiceDetails.scss";
import moment = require("moment");

interface IProps {
	/**
	 * Invoice id.
	 */
	invoiceId: string;
}

interface IState {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
	/**
	 * Payment amount.
	 */
	amountPaid: string;
	/**
	 * Payment date.
	 */
	datePaid: moment.Moment | null;
	/**
	 * Payment method
	 */
	paymentMethod: Option<string>;
	/**
	 * Payment reference.
	 */
	reference: Option<string>;
}

type Props = IProps;

export default class InvoicePaymentTab extends React.Component<Props, IState> {

	/**
	 * Payment methods available for user selection.
	 * @type {string[]}
	 */
	availablePaymentMethods = Object.keys(PaymentMethod).filter(key => PaymentMethod[key as any] !== PaymentMethod.STRIPE_PAYOUT);

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false,
			amountPaid: "",
			datePaid: null,
			paymentMethod: none,
			reference: none
		};
	}

	render() {
		return (
			<div className="c-invoice-details_payments-tab">
				<div className="c-invoice-details_payments-tab_input">
					<CurrencyInputWithIcon value={option(this.state.amountPaid)}
										   onChange={(amount) => this.setState({amountPaid: amount.getOrElse("")})}
										   placeholder={"Amount paid"}/>
				</div>
				<div className="c-invoice-details_payments-tab_input">
					<DatePickerWithIcon onDateChange={(paymentDateTime) => this.setState({datePaid: paymentDateTime})}
										initialDate={this.state.datePaid}
										placeholder={"Date paid"}/>
				</div>
				<div className="c-invoice-details_payments-tab_payment-input">
					<DropDown placeholder={"Payment method"}
							  items={this.availablePaymentMethods}
							  itemToLabel={(item: any) => PaymentMethod[item]}
							  itemToId={(item: string) => item}
							  selectedItemId={this.state.paymentMethod.orNull}
							  onSelect={(item: PaymentMethod) => this.setState({paymentMethod: option(item)})}
							  onClearClick={() => this.setState({paymentMethod: none})}/>
				</div>
				<div className="c-invoice-details_payments-tab_reference-input">
					<Input type={"text"} value={this.state.reference.getOrElse("")}
						   placeholder={"Reference (optional)"}
						   onChange={this.onReferenceChange}/>
				</div>
				<div className="c-invoice-details_payments-tab_submit-button">
					<ButtonPrimary label={"Add Payment"}
								   onClick={this.onSubmit}
								   disabled={this.paymentDataInvalid()}/>
				</div>
			</div>
		);
	}

	onReferenceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.value.length) {
			this.setState({reference: option(event.target.value)});
		}
		else {
			this.setState({reference: none});
		}
	};

	onSubmit = () => {
		this.setState({isLoading: true});
		const payment = Payment.create(
			Number(this.state.amountPaid),
			this.state.datePaid,
			this.state.paymentMethod.orNull,
			this.state.reference);
		// TODO: whole tab is to be deleted atm (unused code), if it changes handle action below in redux (ACCOPAYM-312)
		api.instance.invoicePaymentApi.createInvoicePayment(this.props.invoiceId, payment)
			.then((payment) => {
				this.setState({isLoading: false, amountPaid: "", datePaid: null, paymentMethod: none, reference: none});
				Toast.success("Payment created successfully", "Create payment");
			})
			.catch(this.onFailure)
	};

	onFailure = (error: any) => {
		this.setState({isLoading: false});
		notifyBugsnagAndShowToast(error, "Create payment")
	};

	paymentDataInvalid: () => boolean = () => {
		return this.state.isLoading
			|| !this.state.amountPaid.length
			|| this.state.paymentMethod.isEmpty
			|| this.state.datePaid === null;
	}
}
